import React from 'react';
import moment from 'moment';
import { CSVLink } from "react-csv";
import { useIntl } from 'react-intl';
import {toNativeDate} from "../../Function/globalFunction";

export default function GenerateCSV({ csvData, fromDate, toDate, fullHistory = false }) {
    const intl = useIntl();
    const [filename, setFilename] = React.useState('');
    const title = fullHistory ? 'OTCompensationHistory_' : 'OTCompensationApprovalHistory_';

    React.useEffect(() => {
        let fromDisplayDate = moment(toNativeDate(fromDate)).format(window.global.momentFormat);
        let toDisplayDate = moment(toNativeDate(toDate)).format(window.global.momentFormat);
        setFilename(title + fromDisplayDate + '_To_' + toDisplayDate + '.csv');
    }, [fromDate, toDate]);

    let headers = [];

    if (fullHistory) {
        headers = [
            { label: 'ID', key: "id" },
            { label: intl.formatMessage({ id: 'leave_approval.staff_number' }), key: "staffNo" },
            { label: intl.formatMessage({ id: 'leave_approval.employee' }), key: "employee" },
            { label: intl.formatMessage({ id: 'leave_approval.position' }), key: "position" },
            { label: intl.formatMessage({ id: 'leave_approval.location' }), key: "location" },
            { label: intl.formatMessage({ id: 'leave_approval.department' }), key: "department" },
            { label: intl.formatMessage({id: 'hr_admin.staff_duty'}), key: "staffDuty" },
            { label: intl.formatMessage({ id: 'table.date_submitted' }), key: "dateSubmitted" },
            { label: intl.formatMessage({ id: 'common.from' }), key: "from" },
            { label: intl.formatMessage({ id: 'common.to' }), key: "to" },
            { label: intl.formatMessage({ id: 'comp_leave.justification' }), key: "justification" },
            { label: intl.formatMessage({ id: 'comp_leave.number_of_hours' }), key: "hours" },
            { label: intl.formatMessage({ id: 'table.status' }), key: "status" },
        ];
    } else {
        headers = [
            { label: 'ID', key: "id" },
            { label: intl.formatMessage({ id: 'leave_approval.staff_number' }), key: "staffNo" },
            { label: intl.formatMessage({ id: 'leave_approval.employee' }), key: "employee" },
            { label: intl.formatMessage({ id: 'leave_approval.position' }), key: "position" },
            { label: intl.formatMessage({ id: 'leave_approval.location' }), key: "location" },
            { label: intl.formatMessage({ id: 'leave_approval.department' }), key: "department" },
            { label: intl.formatMessage({id: 'hr_admin.staff_duty'}), key: "staffDuty" },
            { label: intl.formatMessage({ id: 'table.date_submitted' }), key: "dateSubmitted" },
            { label: intl.formatMessage({ id: 'common.from' }), key: "from" },
            { label: intl.formatMessage({ id: 'common.to' }), key: "to" },
            { label: intl.formatMessage({ id: 'comp_leave.justification' }), key: "justification" },
            { label: intl.formatMessage({ id: 'table.status' }), key: "status" },
            { label: intl.formatMessage({ id: 'comp_leave.number_of_hours' }), key: "hours" },
            { label: intl.formatMessage({ id: 'comp_leave.used_comp' }), key: "usedCompLeave" },
            { label: intl.formatMessage({ id: 'comp_leave.used_cash' }), key: "usedCashOut" },
            { label: intl.formatMessage({ id: 'comp_leave.remaining' }), key: "remaining" },
        ];
    }

    return (
        <div>
            {filename ? (
                <CSVLink filename={filename} data={csvData} headers={headers}>
                    <div style={{ color: '#000', opacity: '0.87' }}>
                        {intl.formatMessage({ id: 'leave_approval.export' })}
                    </div>
                </CSVLink>
            ) : null}
        </div>
    );
}